<app-content-module>
  <article
    class="current-item container"
    [class.no-specifications]="!currentItem?.compare_specs?.length"
  >
    <figure
      class="current-item__img"
      *ngIf="currentItem?.compare_specs?.length"
    >
      <app-image
        [src]="currentItem?.images && (currentItem?.images)[0]?.url"
        [alt]="currentItem?.images && (currentItem?.images)[0]?.text"
      ></app-image>
    </figure>
    <section class="current-item__content" [class.multiplan]="isMultiplan()">
      <p class="font--sm"><strong>We are replacing your</strong></p>

      <ng-container
        *ngIf="
          buildConfigService.config?.isBVOverrideEnabled;
          else defaultTitle
        "
      >
        <h4>
          {{ currentItem?.make | uppercase }}
          <span>{{ currentItem?.model }} </span
          >{{ currentItem?.appliance_category }}
        </h4>
      </ng-container>

      <ng-template #defaultTitle>
        <h4 [innerHTML]="currentItem?.long_description | firstUpperBold"></h4>
      </ng-template>
    </section>
  </article>
</app-content-module>
